import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import i18n from "@/config/i18n";
import homeDataBlock from "../home-data-block/home-data-block.vue";
import homeDataTimeType from "../home-data-time-type/home-data-time-type.vue";
import { State } from "vuex-class";
import { getBigRevenueData, getBigChargingData, getBigChargingOrderData, getBigUserData, getEfficiencyData, } from "@/api/api-operation-service";
import { getBigRevenueDataReturn, getBigChargingDataReturn, getBigChargingOrderDataReturn, getBigUserDataReturn, getEfficiencyDataReturn, } from "./js/home-data-line-pie-apidata";
let PiHomeData = class PiHomeData extends Vue {
    constructor() {
        super(...arguments);
        this.active = "3";
        this.chartType = "1";
        this.chargeEchart = {};
        this.myChart = {};
        this.myChartIsSuccess = false;
        this.win = window;
        this.chargeLineData = {};
        this.chargePieData = {};
        this.isActivated = true;
    }
    getVisible() {
        this.resizeBox();
    }
    getVisible2() {
        this.initData();
    }
    /* 图表显示***************************************************** */
    resizeBox() {
        if (this.myChart.id && this.isActivated) {
            this.myChart.resize();
        }
    }
    timeChange(val) {
        this.active = val;
        this.initData();
    }
    chartChange() {
        if (this.chartType == "1") {
            this.chartType = "2";
            this.initPieEchart();
        }
        else {
            this.chartType = "1";
            this.initLineEchart();
        }
    }
    initLineEchart() {
        const series = [];
        const nameArr = [];
        const barWidthObj = {
            3: 3,
            2: 7,
            1: 11,
        };
        this.chargeLineData.data.map((item) => {
            if (this.dataType == "4" || this.dataType == "5") {
                series.push({
                    name: item.name,
                    type: "line",
                    data: item.data,
                    // stack: "Total",
                    emphasis: {
                        focus: "series",
                    },
                    smooth: true,
                    areaStyle: {
                        opacity: 0.8,
                        color: new this.win.echarts.graphic.LinearGradient(0, 0, 0, 1, item.color || [
                            { offset: 0, color: "rgba(0,255,255,1)" },
                            { offset: 1, color: "rgba(0,255,255,0)" },
                        ]),
                    },
                });
            }
            else {
                series.push({
                    name: item.name,
                    type: "bar",
                    barWidth: barWidthObj[this.active] || 3,
                    data: item.data,
                    stack: "all",
                    itemStyle: {
                        color: new this.win.echarts.graphic.LinearGradient(0, 0, 0, 1, item.color || [
                            { offset: 0, color: "rgba(0,255,255,1)" },
                            { offset: 1, color: "rgba(0,255,255,0)" },
                        ]),
                    },
                });
            }
            nameArr.push(item.name);
        });
        let color = this.chargeLineData.color || [
            "#6442FF",
            "#00C7FF",
            "#00FFFF",
            "#B884F5",
            "#B8EF4A",
        ];
        let that = this; //  eslint-disable-line
        const option = {
            tooltip: {
                trigger: "axis",
                formatter: function (params) {
                    var dotHtml = "";
                    var total = 0;
                    console.log(params);
                    params.map((item) => {
                        let value = item.value || 0;
                        dotHtml +=
                            "<div><div style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:" +
                                color[item.seriesIndex] +
                                "'></div>" +
                                item.seriesName +
                                ": " +
                                that.numMax(value) +
                                "</div>";
                        total += value;
                    });
                    if (that.isLineTotal) {
                        total = parseFloat(total.toFixed(4));
                        dotHtml +=
                            "<div><div style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#fff'></div>" +
                                i18n.t("unitText.total") +
                                "(" +
                                that.unit +
                                "): " +
                                that.numMax(total) +
                                "</div>";
                    }
                    return dotHtml;
                },
            },
            legend: {
                orient: "horizontal",
                formatter: "{a|{name}}",
                itemWidth: 8,
                itemHeight: 8,
                icon: "rect",
                textStyle: {
                    rich: {
                        a: {
                            fontSize: 12,
                            color: "rgba(255,255,255,0.8)",
                        },
                    },
                },
                left: "center",
                bottom: 0,
                data: nameArr,
            },
            grid: {
                left: "10%",
                right: "5%",
                bottom: 40,
                top: "10%",
            },
            color: color,
            xAxis: {
                type: "category",
                data: this.chargeLineData.time,
                // boundaryGap: false,
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: "rgba(255,255,255,0.1)",
                    },
                },
                axisLabel: {
                    show: true,
                    textStyle: {
                        color: "#ffffff",
                        fontSize: 12,
                    },
                },
                axisLine: {
                    lineStyle: {
                        color: "rgba(255,255,255,0.1)",
                    },
                },
                axisTick: {
                    show: false,
                },
            },
            yAxis: {
                type: "value",
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: "rgba(255,255,255,0.1)",
                    },
                },
                axisLabel: {
                    show: true,
                    textStyle: {
                        color: "rgba(255,255,255,0.3)",
                    },
                    formatter: (value) => {
                        let name = value + "";
                        if (value >= 10000) {
                            name = parseFloat((value / 10000).toFixed(2)) + "w";
                        }
                        return name;
                    },
                },
                axisLine: {
                    lineStyle: {
                        color: "#32DDFF",
                    },
                    show: false,
                },
                axisTick: {
                    show: false,
                },
            },
            series: series,
        };
        if (Object.keys(this.myChart).length != 0) {
            this.myChart.dispose();
        }
        this.myChart = this.win.echarts.init(this.chargeEchart);
        this.myChart.clear();
        this.myChart.setOption(option, true);
    }
    numMax(value) {
        if (value && value > 10000) {
            return (value / 10000).toFixed(2) + i18n.t("unitText.wan");
        }
        else {
            return value;
        }
    }
    initPieEchart() {
        const title = this.chartType == "1" ? this.titleLine : this.chargePieData.titlePie;
        const legendData = [];
        const legendValue = [];
        this.chargePieData.data.map((item) => {
            legendData.push(item.name);
            legendValue.push(item.value);
        });
        let totalAmount = this.chargePieData.totalAmount;
        let totalTitle = "";
        if (totalAmount >= 10000) {
            totalTitle =
                parseFloat((this.chargePieData.totalAmount / 10000).toFixed(2)) +
                    "" +
                    i18n.t("unitText.wan");
        }
        else {
            totalTitle = totalAmount + ""; //+ i18n.t("unitText.yuan");
        }
        const option = {
            title: {
                text: totalTitle,
                subtext: this.chargePieData.totalName,
                left: "16.5%",
                top: "center",
                textAlign: "center",
                itemGap: 0,
                textStyle: {
                    color: "#fff",
                    fontSize: 17,
                    fontWeight: "normal",
                },
                subtextStyle: {
                    color: "rgba(255,255,255,0.8)",
                    fontSize: 11,
                },
            },
            tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b} : {c} ({d}%)",
            },
            legend: {
                icon: "rect",
                itemHeight: 10,
                itemWidth: 10,
                top: "center",
                orient: "vertical",
                left: "45%",
                itemGap: 14,
                textStyle: {
                    fontSize: 12,
                    color: "#ffffff",
                    rich: {
                        a: {
                            width: 80,
                            fontSize: 12,
                            marginRight: 8,
                            color: "rgba(255,255,255,0.8)",
                        },
                        b: {
                            width: 100,
                            fontSize: 12,
                            align: "right",
                        },
                    },
                },
                data: legendData,
                formatter: (name) => {
                    const i = legendData.indexOf(name);
                    const arr = [
                        "{a| " + name + " }",
                        "{b| " + legendValue[i] + " " + this.unit + " }",
                    ];
                    return arr.join("");
                },
            },
            color: this.chargePieData.color || [
                "#76FF25",
                "#4ADCEF",
                "#B884F5",
                "#B8EF4A",
                "#CF4AEF",
                "#287BE9",
                "#30C292",
                "#7C91E4",
                "#EB6262",
            ],
            series: [
                {
                    name: title,
                    type: "pie",
                    radius: ["90%", "65%"],
                    center: ["18%", "50%"],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: "center",
                    },
                    labelLine: {
                        show: false,
                    },
                    data: this.chargePieData.data,
                },
            ],
        };
        if (Object.keys(this.myChart).length != 0) {
            this.myChart.dispose();
        }
        this.myChart = this.win.echarts.init(this.chargeEchart);
        this.myChart.clear();
        this.myChart.setOption(option, true);
    }
    initData() {
        if (this.dataType == "1") {
            this.getBigRevenueData();
        }
        else if (this.dataType == "2") {
            this.getBigChargingData();
        }
        else if (this.dataType == "3") {
            this.getBigChargingOrderData();
        }
        else if (this.dataType == "4") {
            this.getBigUserData();
        }
        else if (this.dataType == "5") {
            this.getEfficiencyData();
        }
        else {
            this.initLineEchart();
        }
    }
    /*数据获取***************************************************** */
    echartShow(data) {
        const { chargeLineData, chargePieData } = data;
        this.chargeLineData = chargeLineData;
        this.chargePieData = chargePieData;
        if (this.chartType == "1") {
            this.initLineEchart();
        }
        else {
            this.initPieEchart();
        }
    }
    // 获取: 充电营收趋势图
    async getBigRevenueData() {
        const ret = await getBigRevenueData({
            dateType: this.active,
            oprPkId: this.oprPkId,
        });
        if (ret.status === this.$config.apiStatus) {
            this.echartShow(getBigRevenueDataReturn(ret.data));
        }
    }
    // 获取: 充电电量趋势图
    async getBigChargingData() {
        const ret = await getBigChargingData({
            dateType: this.active,
            oprPkId: this.oprPkId,
        });
        if (ret.status === this.$config.apiStatus) {
            this.echartShow(getBigChargingDataReturn(ret.data));
        }
    }
    // 获取: 充电订单趋势图
    async getBigChargingOrderData() {
        const ret = await getBigChargingOrderData({
            dateType: this.active,
            oprPkId: this.oprPkId,
        });
        if (ret.status === this.$config.apiStatus) {
            this.echartShow(getBigChargingOrderDataReturn(ret.data));
        }
    }
    // 获取: 充电用户数量趋势图
    async getBigUserData() {
        const ret = await getBigUserData({
            dateType: this.active,
            oprPkId: this.oprPkId,
        });
        if (ret.status === this.$config.apiStatus) {
            this.echartShow(getBigUserDataReturn(ret.data));
        }
    }
    // 获取: 使用率与利用率趋势图
    async getEfficiencyData() {
        const ret = await getEfficiencyData({
            dateType: this.active,
            oprPkId: this.oprPkId,
        });
        if (ret.status === this.$config.apiStatus) {
            this.echartShow(getEfficiencyDataReturn(ret.data));
        }
    }
    //
    mounted() {
        this.$nextTick(() => {
            this.chargeEchart = this.$refs.echart || {};
            this.initData();
        });
    }
    deactivated() {
        this.isActivated = false;
    }
    activated() {
        let echart = this.$refs.echart;
        if (echart) {
            const secondChild = echart.children[1]; // 注意索引从 0 开始
            if (echart.innerHTML === "" ||
                (secondChild && secondChild.innerHTML === "")) {
                this.initData();
            }
        }
        this.isActivated = true;
    }
};
__decorate([
    Prop({ default: "" })
], PiHomeData.prototype, "oprPkId", void 0);
__decorate([
    Prop({ default: false })
], PiHomeData.prototype, "isLineTotal", void 0);
__decorate([
    Prop({ default: "" })
], PiHomeData.prototype, "titleLine", void 0);
__decorate([
    Prop({ default: "" })
], PiHomeData.prototype, "unit", void 0);
__decorate([
    Prop({ default: "1" })
], PiHomeData.prototype, "dataType", void 0);
__decorate([
    State("sys")
], PiHomeData.prototype, "sys", void 0);
__decorate([
    Watch("sys.winOnresize")
], PiHomeData.prototype, "getVisible", null);
__decorate([
    Watch("oprPkId")
], PiHomeData.prototype, "getVisible2", null);
PiHomeData = __decorate([
    Component({
        components: {
            "pi-home-data-block": homeDataBlock,
            "pi-home-data-time-type": homeDataTimeType,
        },
    })
], PiHomeData);
export default PiHomeData;
